<template>
  <div>
    <!-- <apexchart v-if="ready" width="100%" type="bar" :options="options" :series="series"></apexchart> -->
    <div v-if="ready" id="chart"></div>
    <center v-else>
      <b-spinner type="grow" label="Spinning"></b-spinner>
    </center>
  </div>
</template>

<script>
import axios from "axios";
import * as config from "@/config.json";
import moment from "moment";

export default {
  data: function () {
    return {
      ready: false,
      labels: [],
      total: [],
      quantidade: [],
      ticket: [],
      chart: null,
      series: [],
    };
  },
  props: ["datainicial", "datafinal"],
  watch: {
    datainicial(newValue, oldValue) {
      if (newValue != oldValue) this.updateData();
    },
    datafinal(newValue, oldValue) {
      if (newValue != oldValue) this.updateData();
    },
  },
  methods: {
    async updateData() {
      var inicio = moment(this.datainicial).format("YYYY-MM-DD");
      var fim = moment(this.datafinal).format("YYYY-MM-DD");

      await axios
        .get(
          `${
            config.default.servidor
          }/gerencial/retorna-vendas-por-caixa/${localStorage
            .getItem("enterprise_id")
            .toString()}/${inicio}/${fim}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw==",
            },
          }
        )
        .then((response) => {
          if (response.status == 200) {
            var array = response.data.data;
            var total = [];
            var quantidade = [];
            var ticket = [];
            for (let i = 0; i < array.length; i++) {
              const e = array[i];
              total.push(parseFloat(e.Total).toFixed(2));
              quantidade.push(parseFloat(e.Qtd).toFixed(0));
              ticket.push(parseFloat(e.TicketMedio).toFixed(2));
            }
          }

          this.chart.updateSeries([
            {
              data: total,
            },
            {
              data: quantidade,
            },
            {
              data: ticket,
            },
          ]);
        });
    },
    async fillData() {
      console.warn("Filling data");
      var inicio = moment(this.datainicial).format("YYYY-MM-DD");
      var fim = moment(this.datafinal).format("YYYY-MM-DD");

      const url = `${
        config.default.servidor
      }/gerencial/retorna-vendas-por-caixa/${localStorage
        .getItem("enterprise_id")
        .toString()}/${inicio}/${fim}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: `${config.default.authorizationBasic}` },
        });

        if (response.status == 200) {
          var array = response.data.data;
          for (let i = 0; i < array.length; i++) {
            const e = array[i];
            let total = parseFloat(e.Total).toFixed(2);
            this.labels.push(`Caixa ${e.NumeroCaixa}`);
            this.total.push(total);
            this.quantidade.push(parseFloat(e.Qtd).toFixed(0));
            this.ticket.push(parseFloat(e.TicketMedio).toFixed(2));
          }
          this.ready = true;
        }
      } catch (error) {
        console.log({ error });
        this.ready = false;
      }
    },
  },
  async mounted() {
    await this.fillData();
    this.series = [
      {
        name: "Valor vendido (R$)",
        data: this.total,
      },
      {
        name: "Quantidade vendas",
        data: this.quantidade,
      },
      {
        name: "Ticket médio (R$)",
        data: this.ticket,
      },
    ];
    var options = {
      chart: {
        type: "bar",
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      series: this.series,
      xaxis: {
        categories: this.labels,
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
            // return "R$ " + val;
          },
        },
      },
    };

    this.chart = new ApexCharts(document.getElementById("chart"), options);
    this.chart.render();
  },
};
</script>
